import type { FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { getErrorMsg } from '@wellesley/error-kit/helpers/getErrorMsg'
import { toast } from '@wellesley/system-toast'

export type ServerApiError = {
  errorCode: string
  message?: string
}

// TODO: should be moved to helpers folder and import of this should be updated
export const handleBasicResponse = async <T extends Promise<unknown>>(
  queryFulfilled: T,
  successMsg?: string,
  onError?: () => void | undefined,
) => {
  try {
    await queryFulfilled
    successMsg && toast.success(successMsg)
    return queryFulfilled
  } catch (e) {
    onError?.()
    toast.error(`${getErrorMsg(e as FetchBaseQueryError)}`)
  }
}
